import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

export let isBackPressed = false;
export const setBackPress = (backPress: boolean) => {
  isBackPressed = backPress;
};

export type BrowserOptions = {
  previousPage?: string;
};
let browserOptions: BrowserOptions = {};
export const useBrowserBack = (
  callback?: (option?: BrowserOptions) => void
) => {
  const pathName = useRef(null);
  const dispatch = useDispatch();
  useEffect(() => {
    pathName.current = window.location.pathname;
    dispatch({
      type: 'VALIDATE_NGNIS_ADDRESS_RESET'
    });
    if (isBackPressed) {
      if (typeof callback === 'function') {
        callback(browserOptions);
      }
      isBackPressed = false;
    }
    window.addEventListener('popstate', setBackPress);
    return () => {
      window.removeEventListener('popstate', setBackPress);
    };
  }, []);

  const setBackPress = event => {
    browserOptions.previousPage = pathName.current;
    isBackPressed = true;
  };
  return { isBackPressed, setBackPress, backForwardData: browserOptions };
};
